import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useGetClient(id, dispatch) {
	const url = `/get/client/${id}`;

	return useQuery(['getClient', id], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
